import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import missionImg from './img/mission-img.avif';
import css from './AboutPage.module.css';

const SectionMission = () => {
  return (
    <div className={css.sectionMission}>
      <div className={css.missionContent}>
        <h2 className={css.missionTitle}>
          <FormattedMessage
            id="AboutPage.missionTitle"
            values={{
              textBreak: <br />,
            }}
          />
        </h2>
        <p className={css.missionText}>
          <FormattedMessage id="AboutPage.missionText" />
        </p>
      </div>
      <img className={css.missionImg} loading="lazy" src={missionImg} alt="Vision" />
    </div>
  );
};

export default SectionMission;
